'use strict';
fetch('assets/js/data.json').then((response) => {
  return response.json();
}).then((data) => {

  class newPlayer {
    constructor(player){
      this.playerName = player;
      this.point = 1;
      this.turn = 1;
      this.maxCase = 12;
    }

    static newCase(nbr, p){
      p.point = nbr + p.point;
      if(p.point > p.maxCase){
        p.point = p.point - p.maxCase;
      }
      p.turn+=1;
    }
  }


  const inSize = document.querySelector("#inSize");
  const outSize = document.querySelector("#outSize");

  if(window.innerWidth > 1020 && window.innerWidth < 1400){
    inSize.classList.remove("hide");
    outSize.classList.add("hide");
  }else{
    inSize.classList.add("hide");
    outSize.classList.remove("hide");
  }

  const sections = document.querySelectorAll("section");
  var players = [];
  let lastSection = sections.length - 1;
  let beforeEnd = sections.length - 2;
  const goodScrappy = document.querySelector("#goodScrappy");
  const badScrappy = document.querySelector("#badScrappy");
  let goodPlayer;
  let scrappy = "";
  const assosQuestions = data.association;
  const assosLength = assosQuestions.length;
  const assosDiv = document.querySelector("#assos");
  const assosBtn = document.querySelector("#assosBtn");
  const mimeQuestions = data.mime;
  const mimeLength = mimeQuestions.length;
  const mimeText = document.querySelector("#mimeText");
  const mimeBtn = document.querySelector("#mimeBtn");
  const mimeImg = document.querySelector("#mimeImg");
  const timer = document.querySelector("#timer");
  const musicQuestions = data.music[0];
  const musicLength = musicQuestions.length;
  const artists = data.music[1];
  const artistLength = artists.length;
  const artistsList = document.querySelector("#artistsList");
  var secondsSet = 30;
  const chronometer = document.querySelector("#chrono");
  const nameOfCurrentPlayer = document.querySelector("#currentPlayer");
  const enigmeQuestions = data.enigme;
  const enigmeLength = enigmeQuestions.length;
  const textQuestion = document.querySelector('#question');
  const enigmeList = document.querySelector('#enigmeList');
  const nextBtn = document.querySelector("#next");
  const beginGame = document.querySelector("#togame");
  const enigmeBtn = document.querySelector("#enigmeNext");
  const diceBtn = document.querySelector("#diceButton");
  const dice = document.querySelector(".dice");
  const divScrappy = document.querySelector(".scrappies");
  const phrases = data.phrases;
  const phrasesLength = phrases.length;
  const adventure = document.querySelector("#adventure");

  //intro
  setTimeout(() => {
    nextPage(sections[0], sections[1]);
  },2000)

  //regle
  nextBtn.addEventListener("click", ()=>{
    nextPage(sections[1], sections[2]);
  })

  //story
  beginGame.addEventListener("click", ()=>{
    nextPage(sections[2], sections[3]);
  })

  //choice
  const formSubmit = document.querySelector(".flex--playerchoice");
  const submitBtn = document.querySelector("#submitBtn");
  const inputs = document.querySelectorAll("input");
  var playerNameOne, playerNameTwo, playerNameThd, playerNameFor;

  inputs.forEach((input) => {
    input.addEventListener("input", () => {
      playerNameOne = document.querySelector('#playerNameOne').value;
      playerNameTwo = document.querySelector('#playerNameTwo').value;
      playerNameThd = document.querySelector('#playerNameThd').value;
      playerNameFor = document.querySelector('#playerNameFor').value;
      if(playerNameOne != "" && playerNameTwo != "" && playerNameThd != "" && playerNameFor != ""){
        submitBtn.disabled = false;
      }
    })
  })

  formSubmit.addEventListener("submit", (e)=>{
    e.preventDefault();
    var playerOne = new newPlayer(playerNameOne);
    var playerTwo = new newPlayer(playerNameTwo);
    var playerThd = new newPlayer(playerNameThd);
    var playerFor = new newPlayer(playerNameFor);

    players = [playerOne, playerTwo, playerThd, playerFor];
    goodPlayer = playerOne;
    nextPage(sections[3], sections[4]);
    nameOfCurrentPlayer.innerHTML = playerOne.playerName;
    divScrappy.classList.remove("hide");
  })


 //fin
    const nextPlayer = document.querySelector("#nextPlayer");
    nextPlayer.addEventListener("click", ()=>{
      let turnForOne = players[0].turn;
      let turnForTwo = players[1].turn;
      let turnForThd = players[2].turn;
      let turnForFor = players[3].turn;

      if(turnForOne == turnForTwo && turnForOne == turnForThd && turnForOne == turnForFor){
        goodPlayer = players[0];
      }else if(turnForTwo == turnForThd && turnForTwo == turnForFor){
        goodPlayer = players[1];
      }else if(turnForThd == turnForFor){
        goodPlayer = players[2];
      }else{
        goodPlayer = players[3];
      }

      if(badScrappy.innerHTML <= 0){
        sections[beforeEnd].classList.add("hide");
        sections[lastSection].classList.remove("hide");
      }else{
        sections[beforeEnd].classList.add("hide");
        sections[4].classList.remove("hide");
        nameOfCurrentPlayer.innerHTML = goodPlayer.playerName;
        diceBtn.disabled = false;
      }
    })

    diceBtn.addEventListener("click", () => {
      dice.classList.add("dice--anim");
      diceBtn.disabled = true;
      if(dice.classList.contains("dice--back") || dice.classList.contains("dice--front") || dice.classList.contains("dice--left") || dice.classList.contains("dice--right") || dice.classList.contains("dice--top") || dice.classList.contains("dice--bottom")){
        dice.classList.remove("dice--back");
        dice.classList.remove("dice--front");
        dice.classList.remove("dice--bottom");
        dice.classList.remove("dice--top");
        dice.classList.remove("dice--left");
        dice.classList.remove("dice--right");
      }
      let randomUnit = Math.round(Math.random() * 5) + 1;
      //console.log(goodPlayer);
      newPlayer.newCase(randomUnit, goodPlayer);
      let randomPhrase = Math.round(Math.random() * (phrasesLength - 1));
      adventure.innerHTML = `${goodPlayer.playerName} ${phrases[randomPhrase]}`;
      switch (randomUnit) {
        case 1:
          dice.classList.add("dice--back");
          break;
        case 2:
          dice.classList.add("dice--left");
          break;
        case 3:
          dice.classList.add("dice--top");
          break;
        case 4:
          dice.classList.add("dice--bottom");
          break;
        case 5:
          dice.classList.add("dice--right");
          break;
        default:
          dice.classList.add("dice--front");
      }

      setTimeout(()=>{
        let unitPage = goodPlayer.point;
        //console.log(goodPlayer);
        dice.classList.remove("dice--anim");

        switch(unitPage){
          case 1:
          case 4:
          case 9:
            sections[4].classList.add("hide");
            sections[6].classList.remove("hide");
            //console.log("charge mime");
            mime();
            break;
          case 2:
          case 6:
          case 11:
            sections[4].classList.add("hide");
            sections[5].classList.remove("hide");
            //console.log("charge association");
            association();
            break;
          case 3:
          case 7:
          case 10:
            sections[4].classList.add("hide");
            sections[8].classList.remove("hide");
            //console.log("charge enigme");
            enigme();
            break;
          default:
            sections[4].classList.add("hide");
            sections[7].classList.remove("hide");
            //console.log("charge music");
            music(sections, beforeEnd);
        }
      }, 4000);
    })

    assosBtn.addEventListener("click", () => {
      if(badScrappy.innerHTML <= 0){
        sections[5].classList.add("hide");
        sections[lastSection].classList.remove("hide");
      }else{
        if(scrappy == "good"){
          goodScrappy.innerHTML = parseInt(goodScrappy.innerHTML) + 1;
          badScrappy.innerHTML = parseInt(badScrappy.innerHTML) - 1;
        }
        lastPage(sections[5], sections, beforeEnd);
      }
    })

    mimeBtn.addEventListener("click", () => {
      goodScrappy.innerHTML = parseInt(goodScrappy.innerHTML) + 1;
      badScrappy.innerHTML = parseInt(badScrappy.innerHTML) - 1;
      if(badScrappy.innerHTML <= 0){
        sections[6].classList.add("hide");
        sections[lastSection].classList.remove("hide");
      }else{
        lastPage(sections[6], sections, beforeEnd);
      }
    })

    enigmeBtn.addEventListener("click", ()=>{
      if(badScrappy.innerHTML <= 0){
        sections[8].classList.add("hide");
        sections[lastSection].classList.remove("hide");
      }else{
        if(scrappy == "good"){
          goodScrappy.innerHTML = parseInt(goodScrappy.innerHTML) + 1;
          badScrappy.innerHTML = parseInt(badScrappy.innerHTML) - 1;
        }

        lastPage(sections[8], sections, beforeEnd);
      }
    });


  function nextPage(section, otherSection){
    section.classList.add("hide");
    otherSection.classList.remove("hide");
  }

  function lastPage(section, sections, beforeEnd){
    section.classList.add("hide");
    sections[beforeEnd].classList.remove("hide");
  }

  function association(){
    let randomAssos = Math.round(Math.random() * (assosLength - 1));
    let assosChoose = assosQuestions[randomAssos];
    assosDiv.innerHTML = "";
    assosBtn.disabled = true;
    if(assosChoose.id == "place" || assosChoose.id == "print"){
      let img = document.createElement("img");
      img.setAttribute("src", assosChoose.img);
      let p = document.createElement("p");
      p.innerHTML = assosChoose.question;
      let assosArray = assosChoose.reponses;
      let ul = document.createElement("ul");
      assosArray.forEach((el) => {
        let li = document.createElement("li");
        li.innerHTML = el;
        li.classList.add("association__el");
        ul.appendChild(li);
        li.addEventListener("click", () => {
          if(li.innerHTML == assosChoose.answer){
            li.classList.add("answer--good");
            scrappy = "good";
          }else{
            li.classList.add("answer--bad");
            scrappy = "bad";
          }
          assosBtn.disabled = false;
        })
      })
      assosDiv.appendChild(img);
      assosDiv.appendChild(p);
      assosDiv.appendChild(ul);
    }else{
      let audio = document.createElement("audio");
      audio.setAttribute("src", assosChoose.sound);
      audio.play();
      let p = document.createElement("p");
      p.innerHTML = assosChoose.question;
      let assosArray = assosChoose.reponses;
      let ul = document.createElement("ul");
      assosArray.forEach((el) => {
        let li = document.createElement("li");
        li.innerHTML = el;
        ul.appendChild(li);

        li.addEventListener("click", () => {
          if(li.innerHTML == assosChoose.answer){
            li.classList.add("answer--good");
            scrappy = "good";
          }else{
            li.classList.add("answer--bad");
            scrappy = "bad";
          }
          assosBtn.disabled = false;
        })
      })
      assosDiv.appendChild(audio);
      assosDiv.appendChild(p);
      assosDiv.appendChild(ul);

      if(audio.ended == true){
        lastPage(sections[5], sections, beforeEnd);
      }

      assosBtn.addEventListener("click", () => {
        audio.pause();
      })
    }
  }

  function mime(){
    let randomMime = Math.round(Math.random() * (mimeLength - 1));
    mimeText.innerHTML = `Mime ${mimeQuestions[randomMime].thing}`;
    mimeImg.setAttribute("src", mimeQuestions[randomMime].img);
    let secondsSet = 30;
    timer.innerHTML = secondsSet;
    let chrono = setInterval(function(){
      secondsSet-=1;
      timer.innerHTML = secondsSet;
      if(secondsSet == 0){
        clearInterval(chrono);
        lastPage(sections[6], sections, beforeEnd);
      }
    }, 1000);

    mimeBtn.addEventListener("click", ()=>{
      clearInterval(chrono);
    })
  }

  function music(sections, beforeEnd){
    let randomMusic = Math.round(Math.random() * (musicLength - 1));
    let musicChoose = musicQuestions[randomMusic];
    //console.log(musicChoose, randomMusic);
    let musicResponse = musicChoose.answer;
    artistsList.innerHTML = "";
    let randomOthers = [];
    for(let i = 0; i < 3; i+=1){
      let randomArtist = Math.round(Math.random() * (artistLength - 1));
      let artist = artists[randomArtist];
      if(randomOthers[0] == undefined && artist != musicResponse){
        randomOthers.push(artist);
      }else if(randomOthers[1] == undefined && artist != randomOthers[0] && artist != musicResponse){
        randomOthers.push(artist);
      }else if(randomOthers[2] == undefined && artist != randomOthers[0] && artist != randomOthers[1] && artist != musicResponse){
        randomOthers.push(artist);
      }else{
        i-=1;
      }
    }
    randomOthers.push(musicResponse);
    shuffle(randomOthers);
    let secondsSet = 30;
    chronometer.innerHTML = secondsSet;
    let counter = setInterval(function(){
      secondsSet-=1;
      chronometer.innerHTML = secondsSet;
      if(secondsSet == 0){
        clearInterval(counter);
        lastPage(sections[7], sections, beforeEnd);
      }
    }, 1000);
    //console.log(randomOthers);
    let audio = document.querySelector("#musicAudio");
    audio.setAttribute("src", musicChoose.sound);
    audio.play();

    if(audio.ended == true){
      lastPage(sections[7], sections, beforeEnd);
    }
    randomOthers.forEach((possibility) => {
      let li = document.createElement("li");
      li.innerHTML = possibility;
      artistsList.appendChild(li);
      //console.log(possibility);

      li.addEventListener("click", (e) => {
        e.preventDefault();
        clearInterval(counter);
        if(e.currentTarget.innerHTML == musicResponse){
          e.currentTarget.classList.add("answer--good");
          scrappy = "good";
        }else{
          e.currentTarget.classList.add("answer--bad");
          scrappy = "bad";
        }
        setTimeout(() => {
          audio.pause();
          if(badScrappy.innerHTML <= 0){
            sections[7].classList.add("hide");
            sections[lastSection].classList.remove("hide");
          }else{
            if(scrappy == "good"){
              goodScrappy.innerHTML = parseInt(goodScrappy.innerHTML) + 1;
              badScrappy.innerHTML = parseInt(badScrappy.innerHTML) - 1;
            }

            lastPage(sections[7], sections, beforeEnd);
          }
        }, 2000)
      })
    })
  }

  function enigme(){
    let randomEnigme = Math.round(Math.random() * (enigmeLength - 1));
    enigmeBtn.disabled = true;
    let enigmeChoice = enigmeQuestions[randomEnigme];
    enigmeList.innerHTML = "";
    textQuestion.innerHTML = enigmeChoice.question;
    let possibilities = enigmeChoice.reponses;
    let questionLength = possibilities.length;
    shuffle(possibilities);
    for(let i = 0; i < questionLength; i+=1){
      let li = document.createElement("li");
      li.innerHTML = possibilities[i];
      enigmeList.appendChild(li);

      li.addEventListener("click", (e) =>{
        if(e.currentTarget.innerHTML == enigmeChoice.answer){
          e.currentTarget.classList.add("answer--good");
          scrappy = "good";
        }else{
          e.currentTarget.classList.add("answer--bad");
          scrappy = "bad";
        }

        enigmeBtn.disabled = false;
      })
    }
  }

  /*this function was take from https://stackoverflow.com/questions/6274339/how-can-i-shuffle-an-array */
  function shuffle(a) {
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }
})
